export default "__VITE_ASSET__zhGLXhTz__"